module.exports = __webpack_public_path__ + "img/order-step5-c.d25cbc53.png";